const AdsData = [
	{
		id: 1,
		isSponsored: true,
		owner: "Ade Phones and accessories",
		title: "Apple MacBook Pro, 2019",
		location: "Lekki Phase 1, Lagos",
		category: "phone",
		price: "250,000",
		link: "https://example.com",
		createdAt: "5 mins ago",

	},
	{
		id: 2,
		isSponsored: false,
		owner: "@eddyslanley - Twitter",
		title: "iPhone 11 Pro Max (256gig)",
		location: "Victoria Island, Lagos",
		category: "phone",
		price: "250,000",
		link: "https://example.com",
		createdAt: "30 mins ago",

	},
	{
		id: 3,
		isSponsored: false,
		owner: "@adeolu - IG",
		title: "Play Station 4",
		location: "Ojuelegba, Lagos",
		category: "game",
		price: "90,000",
		link: "https://example.com",
		createdAt: "1 hour ago",

	},
	{
		id: 4,
		isSponsored: false,
		owner: "@oniicode - Twitter",
		title: "HP Envy Laptop",
		location: "Odili Road, Port Harcourt",
		category: "pc",
		price: "250,000",
		link: "https://example.com",
		createdAt: "1 hour ago",

	},
	{
		id: 5,
		isSponsored: false,
		owner: "@eddyslanley",
		title: "Brand New Oven",
		location: "Trans-Amadi, Port Harcourt",
		category: "baking",
		price: "400,000",
		link: "https://example.com",
		createdAt: "2 hours ago",

	},
	{
		id: 6,
		isSponsored: false,
		owner: "@jeffHardy - Twitter",
		title: "Honda Accord Crosstour",
		location: "Old GRA, Port Harcourt",
		category: "vehicle",
		price: "6,650,000",
		link: "https://example.com",
		createdAt: "3 hours ago",

	},
]

export default AdsData